import { connect } from 'react-redux';
import actions from '../../../actions/player';
import PlayersSelectList from './PlayersSelectList';

export default connect(
  ({ player: { items, list = [], loading }}) => ({
    items: list.map(id => items[id]),
    loading
  }),
  dispatch => ({
    load: () => dispatch(actions.fetchList())
  })
)(PlayersSelectList);




// WEBPACK FOOTER //
// ./src/components/Players/PlayersSelectList/index.js